module.exports = {
	'+': 'Pass',
	'-': 'Fail',
	'~': 'SoftFail',
	'?': 'Neutral'
};



// WEBPACK FOOTER //
// ./src/spf-parse/prefixes.js